import { render, staticRenderFns } from "./EventTable.vue?vue&type=template&id=e1256418"
import script from "./EventTable.vue?vue&type=script&lang=js"
export * from "./EventTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports